import { connect } from "react-redux";
import { hideFullscreenViewAction } from "redux-store/ui-state/fullscreen-view";
import { FullScreenView } from "ui/fullscreen-view";

function mapStateToProps(state) {
  const { url, filename, mediaType } = state.pages.fullscreenView;

  return {
    url,
    filename,
    mediaType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    hide: () => {
      dispatch(hideFullscreenViewAction);
    },
  };
}

const ConnectedFullScreenView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FullScreenView);

export { ConnectedFullScreenView };
